/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useMemo } from "react";
import { Dropdown, Divider, Button, Menu, Modal, message } from "antd";
// import { useParams } from "react-router-dom";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { DownOutlined, AppstoreOutlined, PhoneOutlined, TeamOutlined } from "@ant-design/icons";
import Timer from "@/component/Timer";
import style from "./style.module.scss";
import styled from "styled-components";
import aimg from "./img/img";
import { ConferenceInterface } from "@/types";
import { METTINGPAGE_SAVED_MEETING_INFO } from "@/config/const";
import { storage } from "@/util";

const LayoutMenu = styled.div<{ aimg: any }>`
  // width: 660px;
  display: flex;
  padding: 0 5px;
  gap: 5px;
  justify-content: space-around;
  .item {
    cursor: pointer;
    padding-top: 8px;
    padding-bottom: 5px;
    .icon {
      width: 150px;
      height: 100px;
      background: #aaa;
      border: 2px solid transparent;
      border-radius: 4px;
      transition: border-color 0.4s;
      &[data-type="gallery"] {
        background: url(${(p) => p.aimg.gallery}) 0 0 no-repeat;
        background-size: 146px 96px;
        &:hover {
          background-position: 0 1px;
          background-image: url(${(p) => p.aimg.galleryActive});
        }
      }
      &[data-type="thumbnail"] {
        background: url(${(p) => p.aimg.thumbnail}) 0 0 no-repeat;
        background-size: 146px 96px;
        &:hover {
          background-position: 0 1px;
          background-image: url(${(p) => p.aimg.thumbnailActive});
        }
      }
      &[data-type="side"] {
        background: url(${(p) => p.aimg.side}) 0 0 no-repeat;
        background-size: 146px 96px;
        &:hover {
          background-position: 0 1px;
          background-image: url(${(p) => p.aimg.sideActive});
        }
      }
      &[data-type="speaker"] {
        background: url(${(p) => p.aimg.speaker}) 0 0 no-repeat;
        background-size: 146px 96px;
        &:hover {
          background-image: url(${(p) => p.aimg.speakerActive});
        }
      }
      &[data-type="dual"] {
        background: url(${(p) => p.aimg.dual}) 0 0 no-repeat;
        background-size: 146px 96px;
        &:hover {
          background-image: url(${(p) => p.aimg.dualActive});
        }
      }
    }
    &.active .icon {
      border-color: #1890ff;
    }
    .atitle {
      text-align: center;
    }
  }
`;

const Img = (props: any) => {
  const {
    layout,
    onLayoutChange,
    isMonitorMode,
    galleryPageSize,
    onGalleryPageSizeChange,
    videoFitMode,
    onVideoFitModeChange,
    participantsVisible,
    onToggleParticipants,
    onMonitorLeave,
  } = props;
  const conf: ConferenceInterface = storage.get(METTINGPAGE_SAVED_MEETING_INFO);

  const menuData = useMemo(
    () => [
      { name: "gallery", title: "宫格视图" },
      { name: "thumbnail", title: "缩略图视图" },
      { name: "side", title: "侧边视图" },
      { name: "speaker", title: "演讲者视图" },
      { name: "dual", title: "双屏视图" },
    ],
    []
  );
//语音激励回调
  const menuInfo = (
    <div className={`${style.menu} ${style.info}`}>
      <div className="fw5 fs16 mb10">{conf.title}</div>
      <div className="hidden fs12 c9 mb10">
        <div className="w65 fl">会议ID</div>
        <div>{conf.conferenceNo}</div>
      </div>
      <div className="hidden fs12 c9">
        <div className="w65 fl">会议主题</div>
        <div>{conf.title}</div>
      </div>
      <div className="fe mt15">
        <CopyToClipboard
          text={`会议ID: ${conf.conferenceNo}\n会议链接:  https://${window.location.hostname}/`}
          onCopy={() => message.success("复制成功")}
        >
          <Button style={{ marginRight: 16 }}>复制入会信息</Button>
        </CopyToClipboard>
      </div>
      {/* <CopyToClipboard
        text={`会议ID: ${cid}\n会议链接: http://localhost:3000/conf\n电话拨入: +86 10 8888 8888(中国大陆)`}
        onCopy={() => message.success("复制成功")}
      >
        <Button style={{ marginRight: 16 }}>复制入会信息</Button>
      </CopyToClipboard> */}

      {/* <Button>分享至会话</Button> */}
    </div>
  );
// 演讲者视图菜单
  const menu = (
    <LayoutMenu className={style.menu} aimg={aimg}>
      {menuData.map((d: any) => (
        <div
          key={d.name}
          onClick={() => {
            onLayoutChange(d.name)
          
          }}
          className={`item ${layout === d.name ? "active" : ""}`}
        >
          <div className="icon" data-type={d.name} />
          <div className="atitle mt5">{d.title}</div>
        </div>
      ))}
    </LayoutMenu>
  );

  const gallerySizeMenu = (
    <Menu
      selectedKeys={[String(galleryPageSize)]}
      onClick={({ key }) => onGalleryPageSizeChange(Number(key))}
    >
      {[9, 16, 25, 36, 49, 64, 81].map((size) => (
        <Menu.Item key={String(size)}>{size} 宫格</Menu.Item>
      ))}
    </Menu>
  );

  const videoFitMenu = (
    <Menu
      selectedKeys={[videoFitMode]}
      onClick={({ key }) => onVideoFitModeChange(key)}
    >
      <Menu.Item key="cover">充满</Menu.Item>
      <Menu.Item key="contain">按比例</Menu.Item>
    </Menu>
  );

  const confirmMonitorLeave = () => {
    Modal.confirm({
      title: "离开会议",
      content: "确定要退出当前旁听会议吗？",
      okText: "离会",
      cancelText: "取消",
      onOk: onMonitorLeave,
    });
  };

  return (
    <div className={style.container}>
      {isMonitorMode && (
        <Button
          className={style.monitorLeave}
          type="text"
          danger
          size="small"
          icon={<PhoneOutlined rotate={225} />}
          onClick={confirmMonitorLeave}
        >
          离会
        </Button>
      )}
      <Dropdown overlay={menuInfo} trigger={["click"]}>
        <span className={style.dropdown}>
          ID: {conf.conferenceNo} <DownOutlined />
        </span>
      </Dropdown>
      <Divider type="vertical" />
      <Timer />
      <span className={style.meetingTitle} title={conf.title}>{conf.title}</span>

      <div className={style.rightControls}>
        {isMonitorMode && (
          <Dropdown overlay={videoFitMenu} trigger={["click"]}>
            <span className={style.dropdown}>
              画面：{videoFitMode === "cover" ? "充满" : "按比例"} <DownOutlined />
            </span>
          </Dropdown>
        )}
        {isMonitorMode && layout === "gallery" && (
          <Dropdown overlay={gallerySizeMenu} trigger={["click"]}>
            <span className={style.dropdown}>
              {galleryPageSize} 宫格 <DownOutlined />
            </span>
          </Dropdown>
        )}
        <Dropdown overlay={menu} trigger={["click"]}>
          <span className={style.dropdown}>
            <AppstoreOutlined />
            &nbsp;
            {menuData.find((d) => d.name === layout).title} <DownOutlined />
          </span>
        </Dropdown>
        {isMonitorMode && (
          <Button
            className={style.participantsButton}
            type={participantsVisible ? "primary" : "text"}
            size="small"
            icon={<TeamOutlined />}
            onClick={onToggleParticipants}
          >
            成员列表
          </Button>
        )}
      </div>
    </div>
  );
};

export default Img;
